/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Pricing_Per_MonthInputs */

const en_platform_pricing_per_month = /** @type {(inputs: Platform_Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per month`)
};

const pl_platform_pricing_per_month = /** @type {(inputs: Platform_Pricing_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`miesięcznie`)
};

/**
* | output |
* | --- |
* | "per month" |
*
* @param {Platform_Pricing_Per_MonthInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_pricing_per_month = /** @type {((inputs?: Platform_Pricing_Per_MonthInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Pricing_Per_MonthInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_pricing_per_month(inputs)
	return en_platform_pricing_per_month(inputs)
});